<template>
    <div class="open-app">
        <img :src="logofill_pic" alt="">
        <div class="open-app-body">
            <div class="open-app-name">销巴生活</div>
            <div class="open-app-production">好生活  就是销巴生活</div>
        </div>
        <div class="open-app-btn">
            <span>打开APP</span>
            <wxopenbtn :type="type" :postid="postid" />
        </div>
    </div>
</template>

<script>
    import wxopenbtn from "./wxopenbtn.vue";
    const u = navigator.userAgent;
    export default {
        props: {
            postid :String,
            type: String
        },
        components: {
            wxopenbtn
        },
        data() {
            return {
                logofill_pic: require("@/assets/lifecircle/logo-fill.png"),
            }
        }
    }
</script>

<style lang="less" scoped>
    .open-app{
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        width: 100vw;
        height: 44px;
        padding: 0 15px;
        background: #F5F6F8;
        img{
            margin-right: 5px;
            width: 30px;
            height: 30px;
        }
        .open-app-body{
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 30px;
        }
        .open-app-name{
            line-height: 16px;
            color: rgba(0,0,0,0.8);
            font-size: 16px;
        }
        .open-app-production{
            font-size: 12px;
            // transform: scale(0.5);
            transform: translateX(-25%) scale(0.5);
            letter-spacing: 1.2px;
            color: #999999;
        }
        .open-app-btn {
            position: relative;
            width: 76px;
            height: 30px;
            background: linear-gradient(90deg,#ff7641, #ff0b40);
            border-radius: 22px;
            line-height: 30px;
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            text-align: center;
            color: #ffffff;
        }
        .wx-open-app-btn{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
        .launch-app-contaner{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>